var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShopping(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 800 800",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M579.911,503.331l90.321,-353.658l98.812,0l0,-55.59l-141.988,-0l-21.293,83.369l-574.807,-0.411l61.11,326.288l487.845,-0l-0,0.002Zm11.659,-270.299l-54.836,214.708l-398.523,0l-40.279,-215.061l493.638,0.353Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.813,705.918c49.018,-0 88.897,-39.88 88.897,-88.898c0,-49.019 -39.879,-88.897 -88.897,-88.897l-334.931,-0c-49.018,-0 -88.898,39.878 -88.898,88.897c-0,49.018 39.879,88.898 88.898,88.898c49.019,-0 88.897,-39.88 88.897,-88.898c0,-11.772 -2.306,-23.015 -6.48,-33.307l170.097,-0c-4.175,10.292 -6.482,21.535 -6.482,33.307c0.001,49.018 39.881,88.898 88.899,88.898Zm-301.624,-88.898c0,18.366 -14.941,33.308 -33.307,33.308c-18.366,-0 -33.308,-14.942 -33.308,-33.308c-0,-18.366 14.941,-33.307 33.308,-33.307c18.366,-0 33.307,14.941 33.307,33.307Zm334.932,-0c0,18.366 -14.941,33.308 -33.307,33.308c-18.366,-0 -33.308,-14.942 -33.308,-33.308c0,-18.366 14.942,-33.307 33.308,-33.307c18.366,-0 33.307,14.941 33.307,33.307Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopping);
export default __webpack_public_path__ + "static/media/shopping.24219f8fdeb4f9ee0fa5b7bf6ac5b796.svg";
export { ForwardRef as ReactComponent };